import React from 'react';
import { Star, Phone, Mail } from 'lucide-react';

const ExecutiveTeam = () => {
  const executiveTeam = [
    {
      name: 'Mr. Mukwaya James',
      position: 'Chairperson, Board of Directors',
      image: '/images/mukwaya-james.jpg',
      initials: 'MJ',
      phone: '',
      email: '',
    },
    {
      name: 'Ms. Mukuka Andrews',
      position: 'Director, Fundraising',
      image: '/images/mukuka-andrews.jpeg',
      initials: 'MA',
      phone: '',
      email: '',
    },
    {
      name: 'Mr. Ssewankambwe Nicholas',
      position: 'Founder & Chief Executive Officer',
      image: '/images/ceo.jpg',
      initials: 'SN',
      phone: '+256 701 816 912',
      email: 'rakaicommunityhealthinitiative@gmail.com',
    },
    {
      name: 'Dr. Hira Islam',
      position: 'Advisor & Team Lead - TB Control Project',
      image: '/images/hira-aslam.jpeg',
      initials: 'HI',
    },
    {
      name: 'Dr. Radhika S Adholeya',
      position: 'Vice Chairman, Board of Directors',
      image: '/images/radhika.jpeg',
      initials: 'RA',
      phone: '',
      email: '',
    },
    {
      name: 'Dr. Shiv Kumar',
      position: 'Board Member',
      image: '/images/shiv-kumar.jpeg',
      initials: 'SK',
      phone: '',
      email: '',
    },
  ];

  return (
    <div className="executive-page">
      <link href="https://cdn.jsdelivr.net/npm/bootstrap@5.3.0/dist/css/bootstrap.min.css" rel="stylesheet" />

      {/* Hero */}
      <section className="exec-hero">
        <div className="container">
          <span className="hero-badge">Leadership</span>
          <h1 className="hero-title">Board of Directors</h1>
          <p className="hero-subtitle">
            The visionary leaders guiding Rakai Community Health Initiative with purpose,
            integrity, and a deep commitment to healthier communities.
          </p>
        </div>
      </section>

      {/* Cards */}
      <section className="exec-section">
        <div className="container">
          <div className="row g-4 justify-content-center">
            {executiveTeam.map((member, index) => (
              <div key={index} className="col-xl-4 col-md-6">
                <div className="exec-card" style={{ animationDelay: `${index * 0.1}s` }}>
                  <div className="exec-image-wrap">
                    {member.image ? (
                      <img src={member.image} alt={member.name} className="exec-photo"
                        onError={(e) => {
                          e.target.style.display = 'none';
                          e.target.nextSibling.style.display = 'flex';
                        }}
                      />
                    ) : null}
                    <div className="exec-initials-avatar" style={{ display: member.image ? 'none' : 'flex' }}>
                      <span className="exec-initials">{member.initials}</span>
                    </div>
                    <div className="exec-star-badge"><Star size={16} /></div>
                  </div>
                  <div className="exec-body">
                    <h4 className="exec-name">{member.name}</h4>
                    <p className="exec-position">{member.position}</p>
                    {(member.phone || member.email) && (
                      <div className="exec-contact">
                        {member.phone && (
                          <div className="contact-item">
                            <Phone size={14} />
                            <span>{member.phone}</span>
                          </div>
                        )}
                        {member.email && (
                          <div className="contact-item">
                            <Mail size={14} />
                            <span className="contact-email">{member.email}</span>
                          </div>
                        )}
                      </div>
                    )}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <style jsx>{`
        :root {
          --primary-blue: #2563eb;
          --secondary-blue: #1e40af;
          --accent-teal: #06b6d4;
          --accent-orange: #f59e0b;
          --text-gray: #6b7280;
          --light-gray: #f8fafc;
        }

        .executive-page {
          min-height: 100vh;
          background: var(--light-gray);
          padding-top: 80px;
        }

        /* Hero */
        .exec-hero {
          background: linear-gradient(135deg, var(--secondary-blue) 0%, var(--primary-blue) 50%, #0e7490 100%);
          color: white;
          padding: 5rem 0 4rem;
          text-align: center;
          position: relative;
          overflow: hidden;
        }

        .exec-hero::before {
          content: '';
          position: absolute;
          inset: 0;
          background: url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23ffffff' fill-opacity='0.04'%3E%3Ccircle cx='30' cy='30' r='4'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E");
        }

        .exec-hero .container { position: relative; }

        .hero-badge {
          display: inline-block;
          background: rgba(255,255,255,0.15);
          color: white;
          padding: 0.4rem 1.2rem;
          border-radius: 50px;
          font-size: 0.85rem;
          font-weight: 600;
          letter-spacing: 1px;
          text-transform: uppercase;
          margin-bottom: 1.2rem;
          border: 1px solid rgba(255,255,255,0.2);
        }

        .hero-title {
          font-size: clamp(2.2rem, 5vw, 3.5rem);
          font-weight: 800;
          margin-bottom: 1.2rem;
          line-height: 1.1;
        }

        .hero-subtitle {
          font-size: 1.15rem;
          opacity: 0.88;
          max-width: 620px;
          margin: 0 auto;
          line-height: 1.6;
        }

        /* Section */
        .exec-section { padding: 5rem 0 6rem; }

        /* Cards */
        .exec-card {
          background: white;
          border-radius: 1.5rem;
          overflow: hidden;
          box-shadow: 0 4px 24px rgba(0,0,0,0.08);
          transition: all 0.3s ease;
          height: 100%;
          position: relative;
          animation: fadeUp 0.6s ease-out both;
        }

        .exec-card::before {
          content: '';
          position: absolute;
          top: 0; left: 0; right: 0;
          height: 4px;
          background: linear-gradient(90deg, var(--primary-blue), var(--accent-teal), var(--accent-orange));
          border-radius: 1.5rem 1.5rem 0 0;
        }

        .exec-card:hover {
          transform: translateY(-8px);
          box-shadow: 0 20px 60px rgba(0,0,0,0.14);
        }

        .exec-image-wrap {
          position: relative;
          overflow: hidden;
          aspect-ratio: 3 / 4;
        }

        .exec-photo {
          width: 100%; height: 100%;
          object-fit: cover; object-position: center top;
          display: block; transition: transform 0.35s ease;
        }

        .exec-card:hover .exec-photo { transform: scale(1.05); }

        .exec-initials-avatar {
          width: 100%; aspect-ratio: 3 / 4;
          background: linear-gradient(135deg, var(--primary-blue), var(--accent-teal));
          display: flex; align-items: center; justify-content: center;
        }

        .exec-initials {
          font-size: 4rem; font-weight: 700; color: white;
          letter-spacing: 2px; opacity: 0.9;
        }

        .exec-star-badge {
          position: absolute; top: 1rem; right: 1rem;
          background: var(--accent-orange); color: white;
          width: 36px; height: 36px; border-radius: 50%;
          display: flex; align-items: center; justify-content: center;
          box-shadow: 0 4px 15px rgba(245,158,11,0.4);
        }

        .exec-body { padding: 1.5rem; text-align: center; }

        .exec-name {
          font-size: 1.2rem; font-weight: 700;
          color: var(--secondary-blue); margin-bottom: 0.4rem;
        }

        .exec-position {
          color: var(--accent-orange); font-weight: 600;
          font-size: 0.9rem; margin-bottom: 1rem; line-height: 1.4;
        }

        .exec-contact {
          display: flex; flex-direction: column; gap: 0.4rem;
          align-items: center; border-top: 1px solid rgba(0,0,0,0.06);
          padding-top: 1rem;
        }

        .contact-item {
          display: flex; align-items: center; gap: 0.5rem;
          color: var(--text-gray); font-size: 0.82rem;
        }

        .contact-item svg { color: var(--primary-blue); flex-shrink: 0; }
        .contact-email { word-break: break-all; }

        @keyframes fadeUp {
          from { opacity: 0; transform: translateY(24px); }
          to   { opacity: 1; transform: translateY(0); }
        }

        @media (max-width: 768px) {
          .executive-page { padding-top: 70px; }
          .exec-hero { padding: 3.5rem 0 3rem; }
        }
      `}</style>
    </div>
  );
};

export default ExecutiveTeam;
